import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { cn, renderHtmlChoiceId, renderMarkdown } from "@/lib/utils";
import { ChoiceValueType, FillableChoice } from "@/types/questionnaries";
import { PercentageCircle } from "iconsax-react";
import { FC, RefObject } from "react";

type FillablePartProps = {
  choice: FillableChoice;
  inputRef: RefObject<HTMLTextAreaElement | HTMLInputElement>;
  answerValue: string;
  handleTextChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
};

const FillablePart: FC<FillablePartProps> = ({
  choice,
  inputRef,
  answerValue,
  handleTextChange,
  className,
  disabled,
}) => {
  return (
    <div className={cn("mb-1 pl-2", className)}>
      <Label
        className="inline-block pb-1 pt-[5px] font-normal leading-snug text-muted-foreground"
        htmlFor={`${renderHtmlChoiceId(choice.id)}-text`}
        dangerouslySetInnerHTML={{
          __html: renderMarkdown(choice.statement),
        }}
      />

      {choice.valueType === ChoiceValueType.LongText && (
        <Textarea
          id={`${renderHtmlChoiceId(choice.id)}-text`}
          className="max-w-lg"
          ref={inputRef as RefObject<HTMLTextAreaElement>}
          defaultValue={answerValue}
          onChange={(e) => handleTextChange(e.target.value)}
          disabled={disabled}
        />
      )}

      {choice.valueType !== ChoiceValueType.LongText && (
        <div className="relative w-full max-w-xs shrink-0">
          {choice.valueType === ChoiceValueType.Percentage && (
            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-[#4F5D6D]">
              <PercentageCircle />
            </div>
          )}

          <Input
            id={`${renderHtmlChoiceId(choice.id)}-text`}
            ref={inputRef as RefObject<HTMLInputElement>}
            onChange={(e) => handleTextChange(e.target.value)}
            onKeyDown={(evt) =>
              choice.valueType !== ChoiceValueType.Text &&
              ["e", "E", "+", "-"].includes(evt.key) &&
              evt.preventDefault()
            }
            defaultValue={answerValue}
            className={cn(
              choice.valueType === ChoiceValueType.Percentage && "pr-11",
              choice.valueType !== ChoiceValueType.Text && "text-right",
            )}
            type={choice.valueType === ChoiceValueType.Text ? "text" : "number"}
            step={choice.valueType === ChoiceValueType.Integer ? 1 : undefined}
            min={choice.valueType === ChoiceValueType.Text ? undefined : 0}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default FillablePart;
